import { apiFetch } from '@/api/client'

/**
 * A colleague a lead can be handed to.
 *
 * No role: assigning a lead does not need one, and a list of who administers the system, with
 * addresses, is the step before a targeted phish at the accounts that can export the master data.
 */
export type DirectoryUser = {
  id: string
  firstName: string | null
  lastName: string | null
  email: string | null
  /**
   * False for an account that cannot log in today. Such an entry stays in the list so an existing
   * assignment still has a name against it — it is just not something to hand more work to.
   */
  assignable: boolean
}

export type UserDirectory = {
  users: DirectoryUser[]
  /** When the list was read from Keycloak, so a stale copy can say how old it is. */
  generatedAt: string
}

/** The whole list in one response; it is short and changes about as often as the staff does. */
export function listUserDirectory(signal?: AbortSignal): Promise<UserDirectory> {
  return apiFetch<UserDirectory>('/api/users', { signal })
}
